import { render, staticRenderFns } from "./LoanCollateralAssetVehicleFieldsDisplay.vue?vue&type=template&id=505a0688&scoped=true&lang=pug&"
import script from "./LoanCollateralAssetVehicleFieldsDisplay.vue?vue&type=script&lang=js&"
export * from "./LoanCollateralAssetVehicleFieldsDisplay.vue?vue&type=script&lang=js&"
import style0 from "./LoanCollateralAssetVehicleFieldsDisplay.vue?vue&type=style&index=0&id=505a0688&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505a0688",
  null
  
)

/* custom blocks */
import block0 from "./LoanCollateralAssetVehicleFieldsDisplay.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports